import { render, staticRenderFns } from "./mineMessage.vue?vue&type=template&id=200e582f&scoped=true"
import script from "./mineMessage.vue?vue&type=script&lang=js"
export * from "./mineMessage.vue?vue&type=script&lang=js"
import style0 from "./mineMessage.vue?vue&type=style&index=0&id=200e582f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e582f",
  null
  
)

export default component.exports